const key = (value) => String(value || "").trim().toLowerCase();

const GROUP_STATEMENT_MEMBER_EXCEPTIONS = {
  "36482": {
    adviserNames: new Set(["sumaiya patel"]),
    recipientIds: new Set(["40894626", "148601", "917659"]),
  },
};

const GROUP_STATEMENT_VARIANTS = {
  "36596": [
    {
      id: "marble-mp",
      name: "Marble M&P",
      adviserIds: new Set([
        "kerry@marblefp.com",
        "james@marblefp.com",
        "pippa@marblefp.com",
        "robert@marblefp.com",
        "alan@marblefp.com",
      ]),
    },
    {
      id: "marble-fp",
      name: "Marble FP",
      adviserIds: new Set([
        "liam@marblefp.com",
        "ryan@marblefp.com",
      ]),
    },
  ],
};

const adviserId = (adviser = {}) => key(
  adviser.adviserDocumentId || adviser.id || adviser.email,
);

export const isExcludedGroupStatementAdviser = (groupId, adviser = {}) => {
  const exception = GROUP_STATEMENT_MEMBER_EXCEPTIONS[String(groupId || "").trim()];
  if (!exception) return false;
  if (exception.adviserNames.has(key(adviser.adviser || adviser.name))) return true;
  return (adviser.ioAdviserIds || []).some((identifier) =>
    exception.recipientIds.has(String(identifier).trim()),
  );
};

export const groupStatementVariants = (
  groupId,
  advisers = [],
  defaultName = "",
) => {
  const variants = GROUP_STATEMENT_VARIANTS[String(groupId || "").trim()];
  if (!variants) {
    return [{ id: "", name: defaultName, members: advisers }];
  }
  return variants.map((variant) => ({
    id: variant.id,
    name: variant.name,
    members: advisers.filter((adviser) =>
      variant.adviserIds.has(adviserId(adviser)),
    ),
  }));
};

export const groupStatementVariantForAdviser = (groupId, adviser = {}) => {
  const variants = GROUP_STATEMENT_VARIANTS[String(groupId || "").trim()] || [];
  const id = adviserId(adviser);
  return variants.find((variant) => variant.adviserIds.has(id)) || null;
};

export const hasGroupStatementVariants = (groupId) =>
  Boolean(GROUP_STATEMENT_VARIANTS[String(groupId || "").trim()]);

